import { put, call } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import * as dayjs from 'dayjs';
import * as actions from '../actions/shipment';
import { modalErrorOpen } from '../actions/modalError';
// eslint-disable-next-line import/named
import { post, get, axiosPut } from '../../utils/api';
import {
  modalShipmentPlanClose,
  modalShipmentPlanCancelClose,
  modalShipmentCancelReasonClose,
  modalShipmentAddReportOverdueClose, modalShipmentClientArrivalDateClose
} from '../actions/modal';
import { errorModalOpen, getLocale } from '../../utils/functions';

export function* shipment({ payload }) {
  try {
    const response = yield call(post, '/grid/data/shipment/', {
      dateFrom: payload.dateFrom,
      dateTo: payload.dateTo,
      filter: payload.filter,
      plantId: payload.plantId,
      statusId: payload.statusId ? payload.statusId : null,
      items: payload.items
    });
    const now = new Date();
    const oneDay = 24 * 60 * 60 * 1000;
    yield put(
      actions.getShipmentSuccess(
        response && response.length
          ? response
            .filter((item) => !item.mcNumId)
            .map((item) => ({
              ...item,
              quantityRemain: item.quantityRemain
                ? item.quantityRemain.toFixed(3)
                : item.quantityRemain,
              commonNumber: `${item.heatId === null ? '' : item.heatId}-${
                item.cgId
              }-${item.actualPieceId}`,
              sizes: `${item.thick === null ? '' : item.thick}x${
                item.width === null ? '' : item.width
              }`,
              fullSizes: `${item.thick === null ? 'н/д' : item.thick}x${
                item.width === null ? 'н/д' : item.width}x${
                item.length === null ? 'н/д' : item.length
              }`,
              azhStatusDescr: `${
                // eslint-disable-next-line no-nested-ternary
                item.mh3DocStatusDescr === null
                  ? ''
                  : item.mh3DocStatusDescr === 'Подписан'
                    ? 'Обработан'
                    : item.mh3DocStatusDescr
              }`,
              commonNumberMKM: `${item.qcId}/${item.cgId}/${item.actualPieceId}`,
              endCustomerName: item.endCustomerName === null
                ? item.customerName
                : item.endCustomerName,
              // eslint-disable-next-line no-nested-ternary
              prohibition: `${(item.prohibitionFlag === 'Y')
                ? (`${(item.prohibitionEndDate !== null && item.prohibitionEndDate >= now)}`
                  ? 'Запрет'
                  : '')
                : ''}`,
              buyoutDate: item.incomingDate !== null
                ? dayjs(Date.parse(item.incomingDate) + ((item.storageTimeCount !== null)
                  ? item.storageTimeCount : 0) * oneDay).format('YYYY-MM-DD')
                : null,
              // eslint-disable-next-line no-mixed-operators
              costPerTon: Math.round(item.cost * 100 / item.weightNetto) / 100,
              stornoFlag: item.stornoFlag === 'Y',
              onHoldFlag: item.onHoldFlag === 'Y',
              hasShippingPlan: item.hasShippingPlan === 'Y',
              virtualNetto: item.weightRemain !== null
                ? item.weightRemain <= 0
                  ? 0
                  : item.weightRemain
                : item.weightNetto,
              virtualBrutto: item.weightRemain !== null
                ? item.weightRemain <= 0
                  ? 0
                  : item.weightBrutto - item.weightNetto + item.weightRemain
                : item.weightBrutto,
              wadat_ist: item.invoice ? item.dateOm : ''
            }))
          : response
      )
    );
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getShipmentFail(error.response.data));
  }
}

export function* shipmentCheckFIFO({ payload }) {
  try {
    let response = null;
    const oneDay = 24 * 60 * 60 * 1000;
    response = yield call(post, '/action/shipment/checkfifo/', {
      items: payload.items,
      plantId: payload.plantId
    });
    yield put(
      actions.getShipmentCheckFIFOSuccess(
        response.length > 0
          ? response
            .filter((item) => !item.mcNumId)
            .map((item) => ({
              ...item,
              commonNumber: `${item.heatId === null ? '' : item.heatId}-${
                item.cgId
              }-${item.actualPieceId}`,
              sizes: `${item.thick === null ? '' : item.thick}x${
                item.width === null ? '' : item.width
              }`,
              fullSizes: `${item.thick === null ? 'н/д' : item.thick}x${
                item.width === null ? 'н/д' : item.width}x${
                item.length === null ? 'н/д' : item.length
              }`,
              azhStatusDescr: `${
                // eslint-disable-next-line no-nested-ternary
                item.mh3DocStatusDescr === null
                  ? ''
                  : item.mh3DocStatusDescr === 'Подписан'
                    ? 'Обработан'
                    : item.mh3DocStatusDescr
              }`,
              commonNumberMKM: `${item.qcId}/${item.cgId}/${item.actualPieceId}`,
              buyoutDate: item.incomingDate !== null
                ? dayjs(Date.parse(item.incomingDate) + ((item.storageTimeCount !== null)
                  ? item.storageTimeCount : 0) * oneDay).format('YYYY-MM-DD')
                : null,
              // eslint-disable-next-line no-mixed-operators
              costPerTon: Math.round(item.cost * 100 / item.weightNetto) / 100,
              stornoFlag: item.stornoFlag === 'Y',
              onHoldFlag: item.onHoldFlag === 'Y',
              hasShippingPlan: item.hasShippingPlan === 'Y'
            }))
          : { pieceNumId: -1 }
      )
    );
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getShipmentCheckFIFOFail(error.response.data));
  }
}

export function* shipmentAccept({ payload }) {
  let response = null;
  let limitCheck = true;
  let checkCreditLimit = false;
  let checkDZ = false;
  let checkPDZ = false;
  let errorText = '';
  if (payload.isUseCreditLimitCheck || payload.isUseDZCheck || payload.isUsePDZCheck) {
    limitCheck = false;
    try {
      response = yield call(post, '/action/shipment/check_credit_limit/', {
        items: payload.items,
        docDate: payload.actualShippingDate,
        clientCode: payload.clientId
      });
      if (payload.isUseCreditLimitCheck) {
        if (response.check_kl === 'X') {
          checkCreditLimit = true;
        } else {
          errorText += 'проверка на КЛ';
        }
      }
      if (payload.isUseDZCheck) {
        if (response.check_limit === 'X') {
          checkDZ = true;
        } else {
          if (errorText.length > 0) {
            errorText += ', ';
          }
          errorText += 'превышения уровня ДЗ(предоставленного обеспечения)';
        }
      }
      if (payload.isUsePDZCheck) {
        if (response.check_pdz === 'X') {
          checkPDZ = true;
        } else {
          if (errorText.length > 0) {
            errorText += ', ';
          }
          errorText += 'проверка на ПДЗ';
        }
      }
      if ((checkCreditLimit === false && payload.isUseCreditLimitCheck)
        || (checkDZ === false && payload.isUsePDZCheck)
        || (checkPDZ === false && payload.isUsePDZCheck)) {
        yield put(
          modalErrorOpen({
            message: 'Проверка лимита не пройдена.',
            techInfo: `Выявлены следующие несоответствия: ${errorText}. Прошу обратиться к закрепленному менеджеру по продажам ПАО "Северсталь" за разъяснением.`,
            types: 'info',
            title: formatMessage('textError').warning
          })
        );
        yield put(actions.getShipmentConsignmentAcceptFail());
      } else {
        limitCheck = true;
      }
    } catch (error) {
      yield put(
        modalErrorOpen({
          message: 'Ошибка проверки кредитного лимита',
          techInfo: error.response.data.techInfo,
          types: 'error',
          title: formatMessage('textError').warning
        })
      );
      yield put(actions.getShipmentConsignmentAcceptFail(error.response.data));
    }
  }
  if (limitCheck) {
    try {
      let path;
      if (payload.isOffBalanceSheet) {
        path = '/action/shipment/accept/offBalance';
      } else {
        path = '/action/shipment/accept/';
      }
      response = yield call(post, path, {
        items: payload.items,
        plantId: payload.plantId,
        container: payload.container,
        loadDate: payload.loadDate,
        plomba: payload.plomba,
        ttn: payload.ttn,
        ttnDate: payload.ttnDate,
        vehicle: payload.vehicle,
        ttnDocumentNumId: payload.ttnDocumentNumId,
        actualShippingDate: payload.actualShippingDate,
        nextPlant: payload.nextPlant,
        mh3: payload.mh3,
        containerInspectedFlag: payload.containerInspectedFlag,
        shippingOnBoards: payload.shippingOnBoards,
        rollsPlacementType: payload.rollsPlacementType
      });
      yield put(actions.getShipmentAcceptSuccess(response));
      yield put(actions.getShipment({ plantId: payload.plantId }));
    } catch (error) {
      yield put(errorModalOpen(error));
      yield put(actions.getShipmentAcceptFail(error.response.data));
    }
  }
}

export function* shipmentReject({ payload }) {
  try {
    const response = yield call(post, '/action/shipment/reject/', {
      items: payload.items,
      note: payload.note,
      plantId: payload.plantId
    });
    yield put(actions.getShipmentRejectSuccess(response));
    yield put(modalShipmentCancelReasonClose());
    // yield put(actions.getShipment({ plantId: payload.plantId }));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getShipmentRejectFail(error.response.data));
  }
}

export function* shipmentConsignmentAccept({ payload }) {
  let response = null;
  let limitCheck = true;
  let checkCreditLimit = false;
  let checkDZ = false;
  let checkPDZ = false;
  let errorText = '';
  if (payload.isUseCreditLimitCheck || payload.isUseDZCheck || payload.isUsePDZCheck) {
    limitCheck = false;
    try {
      response = yield call(post, '/action/shipment/check_credit_limit/', {
        items: payload.items,
        docDate: ((payload.mh3Date) !== null ? payload.mh3Date : payload.m15bDate),
        clientCode: payload.clientId
      });
      if (payload.isUseCreditLimitCheck) {
        if (response.check_kl === 'X') {
          checkCreditLimit = true;
        } else {
          errorText += 'проверка на КЛ';
        }
      }
      if (payload.isUseDZCheck) {
        if (response.check_limit === 'X') {
          checkDZ = true;
        } else {
          if (errorText.length > 0) {
            errorText += ', ';
          }
          errorText += 'превышения уровня ДЗ(предоставленного обеспечения)';
        }
      }
      if (payload.isUsePDZCheck) {
        if (response.check_pdz === 'X') {
          checkPDZ = true;
        } else {
          if (errorText.length > 0) {
            errorText += ', ';
          }
          errorText += 'проверка на ПДЗ';
        }
      }
      if ((checkCreditLimit === false && payload.isUseCreditLimitCheck)
        || (checkDZ === false && payload.isUsePDZCheck)
        || (checkPDZ === false && payload.isUsePDZCheck)) {
        yield put(
          modalErrorOpen({
            message: 'Проверка лимита не пройдена.',
            techInfo: `Выявлены следующие несоответствия: ${errorText}. Прошу обратиться к закрепленному менеджеру по продажам ПАО "Северсталь" за разъяснением.`,
            types: 'info',
            title: formatMessage('textError').warning
          })
        );
        yield put(actions.getShipmentConsignmentAcceptFail());
      } else {
        limitCheck = true;
      }
    } catch (error) {
      yield put(
        modalErrorOpen({
          message: 'Ошибка проверки кредитного лимита',
          techInfo: error.response.data.techInfo,
          types: 'error',
          title: formatMessage('textError').warning
        })
      );
      yield put(actions.getShipmentConsignmentAcceptFail(error.response.data));
    }
  }
  if (limitCheck) {
    try {
      if (!payload.m15b) {
        const jsonData = {};
        const formData = new FormData();
        if (payload.file) {
          formData.append('file', payload.file);
        }
        jsonData.items = payload.items;
        jsonData.plantId = payload.plantId;
        jsonData.mh3 = payload.mh3 || null;
        jsonData.mh3Date = payload.mh3Date || null;
        jsonData.ttn = payload.ttn || null;
        jsonData.ttnDate = payload.ttnDate || null;
        jsonData.vehicle = payload.vehicle || null;
        jsonData.actualShippingDate = payload.actualShippingDate || null;
        jsonData.clientCode = payload.clientId || null;
        jsonData.storage = payload.storage || null;
        jsonData.forProduction = payload.forProduction || null;
        jsonData.contractNumId = payload.contractNumId || null;
        formData.append('acceptRequest', JSON.stringify(jsonData));
        response = yield call(post, '/action/shipment/consignment/accept/',
          formData,
          {
            headers: {
              'Accept-Language': getLocale(),
              'Content-Type': 'multipart/form-data'
            }
          });
      } else {
        response = yield call(post, '/action/shipment/processing/buyout/', {
          actualShippingDate: payload.actualShippingDate,
          clientCode: payload.clientId,
          items: payload.items,
          m15b: payload.m15b,
          m15bDate: payload.m15bDate,
          plantId: payload.plantId,
          qcId: payload.qc,
          ttn: payload.ttn,
          ttnDate: payload.ttnDate,
          vehicle: payload.vehicle,
          signDateTime: payload.signDateTime || null,
          signer: payload.signer || null
        });
      }
      yield put(actions.getShipmentConsignmentAcceptSuccess(response));
    } catch (error) {
      yield put(errorModalOpen(error));
      yield put(actions.getShipmentConsignmentAcceptFail(error.response.data));
    }
  }
}

export function* shipmentActRemoveMx3({ payload }) {
  try {
    yield call(post, '/action/shipment/remove/mx3/', {
      items: payload.items,
      plantId: payload.plantId
    });
    yield put(actions.getShipmentActRemoveMh3Success());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getShipmentActRemoveMh3Fail(error.response.data));
  }
}

export function* shipmentActRemoveM15B({ payload }) {
  try {
    yield call(post, '/action/shipment/remove/m15b/', {
      items: payload.items,
      plantId: payload.plantId
    });
    yield put(actions.getShipmentActRemoveM15BSuccess());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getShipmentActRemoveM15BFail(error.response.data));
  }
}

export function* shipmentReturn({ payload }) {
  try {
    yield call(post, '/action/incoming/return/', {
      items: payload.items,
      physical: payload.physical,
      plantId: payload.plantId,
      reason: payload.reason,
      vehicle: payload.vehicle
    });
    yield put(actions.getShipmentReturnSuccess());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getShipmentReturnFail(error.response.data));
  }
}

export function* shipmentReturnListCause({ payload }) {
  try {
    const response = yield call(get, '/list/return_reasons/');
    yield put(actions.getShipmentReturnListCauseSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getShipmentReturnListCauseFail(error.response.data));
  }
}

export function* getShipmentConsignmentClientsList({ payload }) {
  try {
    const response = yield call(
      get,
      `/action/shipment/consignment/clients/${payload.plantId}`
    );
    yield put(
      actions.getShipmentConsignmentClientsListSuccess(
        response.map((item) => ({
          key: Object.keys(item)[0],
          value: item[Object.keys(item)[0]]
        }))
      )
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getShipmentConsignmentClientsListFail());
  }
}

export function* getShipmentPlanContainerType({ payload }) {
  try {
    const response = yield call(get, '/action/shipment/plan/container_type');
    yield put(actions.getShipmentPlanContainerTypeSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getShipmentPlanContainerTypeFail());
  }
}

export function* getShipmentPlan({ payload }) {
  try {
    yield call(post, '/action/shipment/plan/', payload);
    yield put(actions.getShipmentPlanSuccess());
    yield put(modalShipmentPlanClose());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getShipmentPlanFail());
  }
}

export function* getShipmentPlanCancel({ payload }) {
  try {
    yield call(post, '/action/shipment/cancelplan/', {
      items: payload.items,
      plantId: payload.plantId
    });
    yield put(actions.getShipmentPlanCancelSuccess());
    yield put(modalShipmentPlanCancelClose());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getShipmentPlanCancelFail(error.response.data));
  }
}

export function* getNextPlants({ payload }) {
  try {
    const response = yield call(
      get,
      `/action/shipment/next_plants/${payload.plantId}`
    );
    yield put(actions.getNextPlantsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getNextPlantsFail());
  }
}

export function* getNextPlant({ payload }) {
  try {
    let response = yield call(
      get,
      `/action/shipment/next_plant/${payload.pieceNumId}`
    );
    if (response.length === 0) {
      response = '0';
    }
    yield put(actions.getNextPlantSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getNextPlantFail());
  }
}

export function* addItemsToReportOverdue({ payload }) {
  try {
    yield call(post, '/action/shipment/add_to_over_storage/', {
      cost: payload.cost,
      date: payload.date,
      items: payload.items
    });
    yield put(actions.addItemsToReportOverdueSuccess());
    yield put(modalShipmentAddReportOverdueClose());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addItemsToReportOverdueFail(error.response.data));
  }
}

export function* getSZList({ payload }) {
  try {
    let response = yield call(post, '/piece/sz/list', {
      plantId: payload.plant,
      psStatusName: payload.psStatusName,
      thick: payload.thick,
      materialSize: payload.materialSize,
      marka: payload.marka
    });
    if (response.length === 0) {
      response = '0';
    }
    yield put(actions.getSZListSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getSZListFail());
  }
}

export function* updateSZ({ payload }) {
  try {
    yield call(
      axiosPut,
      '/piece/rebinding',
      {
        pieceNumIds: payload.pieceNumIds,
        solNumId: payload.solNumId
      }
    );
    yield call(
      notify,
      {
        message: 'Перепривязка прошла успешно',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(post, '/grid/data/shipment/', {
      dateFrom: payload.dateFrom,
      dateTo: payload.dateTo,
      filter: payload.filter,
      plantId: payload.plantId,
      statusId: payload.statusId ? payload.statusId : null
    });
    const now = new Date();
    const oneDay = 24 * 60 * 60 * 1000;
    yield put(
      actions.getShipmentSuccess(
        response && response.length
          ? response
            .filter((item) => !item.mcNumId)
            .map((item) => ({
              ...item,
              quantityRemain: item.quantityRemain
                ? item.quantityRemain.toFixed(3)
                : item.quantityRemain,
              commonNumber: `${item.heatId === null ? '' : item.heatId}-${
                item.cgId
              }-${item.actualPieceId}`,
              sizes: `${item.thick === null ? '' : item.thick}x${
                item.width === null ? '' : item.width
              }`,
              fullSizes: `${item.thick === null ? 'н/д' : item.thick}x${
                item.width === null ? 'н/д' : item.width}x${
                item.length === null ? 'н/д' : item.length
              }`,
              azhStatusDescr: `${
                // eslint-disable-next-line no-nested-ternary
                item.mh3DocStatusDescr === null
                  ? ''
                  : item.mh3DocStatusDescr === 'Подписан'
                    ? 'Обработан'
                    : item.mh3DocStatusDescr
              }`,
              commonNumberMKM: `${item.qcId}/${item.cgId}/${item.actualPieceId}`,
              endCustomerName: `${(item.endCustomerName === null)
                ? item.customerName
                : item.endCustomerName}`,
              // eslint-disable-next-line no-nested-ternary
              prohibition: `${(item.prohibitionFlag === 'Y')
                ? (`${(item.prohibitionEndDate !== null && item.prohibitionEndDate >= now)}`
                  ? 'Запрет'
                  : '')
                : ''}`,
              buyoutDate: item.incomingDate !== null
                ? dayjs(Date.parse(item.incomingDate) + ((item.storageTimeCount !== null)
                  ? item.storageTimeCount : 0) * oneDay).format('YYYY-MM-DD')
                : null,
              // eslint-disable-next-line no-mixed-operators
              costPerTon: Math.round(item.cost / item.weightNetto) / 100,
              stornoFlag: item.stornoFlag === 'Y',
              onHoldFlag: item.onHoldFlag === 'Y',
              hasShippingPlan: item.hasShippingPlan === 'Y'
            }))
          : response
      )
    );
    yield put(actions.updateSZSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.updateSZFail());
  }
}

export function* getRollsPlacementTypes() {
  try {
    const response = yield call(get, '/action/shipment/accept/rolls_placement_types/');
    yield put(actions.getRollsPlacementTypesSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getRollsPlacementTypesFail());
  }
}

export function* getSeparationsList() {
  try {
    const response = yield call(get, 'action/shipment/separations');
    yield put(actions.getSeparationsListSuccess(response
      .sort((a, b) => a.attrbAnValue.localeCompare(b.attrbAnValue))));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getSeparationsListFail());
  }
}

export function* getSeparationsByPieces({ payload }) {
  try {
    const response = yield call(post,
      'action/shipment/separations', payload.pieceNumIdList || []);
    yield put(actions.getSeparationsByPiecesSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getSeparationsByPiecesFail());
  }
}

export function* addClientArrivalDate({ payload }) {
  try {
    yield call(post, '/action/shipment/client_arrival_date', {
      clientArrivalDate: payload.clientArrivalDate,
      pieceNumIds: payload.pieceNumIds
    });
    yield put(actions.addClientArrivalDateSuccess());
    yield put(actions.getShipment({ plantId: payload.plantId, ...payload.filterDataGrid }));
    yield put(modalShipmentClientArrivalDateClose());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addClientArrivalDateFail(error.response.data));
  }
}
